import {
  QueryBuilderReactPlugin,
  defaultQueryBuilderPlugins
} from '@sierralabs/query-ui';

import { LineChartQueryBuilderPlugin } from './plugins/LineChartQueryBuilderPlugin';
import { TaskDisplayVersionQueryBuilderPlugin } from './plugins/TaskDisplayVersionQueryBuilderPlugin';

export const defaultQmsQueryBuilderPlugins: QueryBuilderReactPlugin[] = [
  ...defaultQueryBuilderPlugins,
  LineChartQueryBuilderPlugin,
  TaskDisplayVersionQueryBuilderPlugin
];
